(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('formdata', (event) => {
    const code = event.target.querySelector('.contact__dial-code select');
    const phone = event.target.querySelector('.contact__phone-number input');
    if (!code || !phone) return;
    const number = phone.value.trim();
    if (!number || /^(\+|00)/.test(number)) {
      event.formData.delete(code.name);
      event.formData.set(phone.name, number);
      return;
    }
    event.formData.set(phone.name, [code.value, number].filter(Boolean).join(' '));
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.querySelectorAll('.tavia-journal-post .article-template__content table').forEach((table) => {
    if (table.parentElement.classList.contains('tavia-journal__table-wrap')) return;
    const wrapper = document.createElement('div');
    wrapper.className = 'tavia-journal__table-wrap';
    wrapper.setAttribute('role', 'region');
    wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || document.querySelector('.article-template__title')?.textContent.trim() || '');
    wrapper.tabIndex = 0;
    table.before(wrapper);
    wrapper.append(table);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tavia-3d-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tavia-comparison')) {
    customElements.define(
      'tavia-comparison',
      class TaviaComparison extends HTMLElement {
        connectedCallback() {
          if (this.dataset.comparisonBound === 'true') return;

          const range = this.querySelector('[data-comparison-range]');
          if (!range) return;

          this.dataset.comparisonBound = 'true';

          const update = () => {
            this.style.setProperty('--comparison-position', `${range.value}%`);
          };

          range.addEventListener('input', update);
          update();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tavia-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tavia-testimonials')) {
    customElements.define(
      'tavia-testimonials',
      class TaviaTestimonials extends HTMLElement {
        connectedCallback() {
          this.rail = this.querySelector('[data-testimonial-rail]');
          this.cards = Array.from(this.querySelectorAll('[data-testimonial-card]'));
          this.previousButton = this.querySelector('[data-testimonial-previous]');
          this.nextButton = this.querySelector('[data-testimonial-next]');

          if (!this.rail || this.cards.length === 0) return;

          this.abortController = new AbortController();
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
          this.activeIndex = Math.min(
            Math.max(Number.parseInt(this.dataset.initialIndex, 10) || 0, 0),
            this.cards.length - 1
          );

          this.previousButton?.addEventListener('click', () => this.select(this.activeIndex - 1, true), {
            signal: this.abortController.signal,
          });
          this.nextButton?.addEventListener('click', () => this.select(this.activeIndex + 1, true), {
            signal: this.abortController.signal,
          });

          this.cards.forEach((card, index) => {
            card.addEventListener('click', () => this.select(index, true), { signal: this.abortController.signal });
            card.addEventListener('focus', () => this.select(index, true), { signal: this.abortController.signal });
            card.addEventListener(
              'keydown',
              (event) => {
                if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
                  event.preventDefault();
                  const direction = event.key === 'ArrowLeft' ? -1 : 1;
                  const nextIndex = Math.min(Math.max(index + direction, 0), this.cards.length - 1);
                  this.cards[nextIndex].focus();
                }
              },
              { signal: this.abortController.signal }
            );
          });

          this.rail.addEventListener(
            'scroll',
            () => {
              window.cancelAnimationFrame(this.scrollFrame);
              this.scrollFrame = window.requestAnimationFrame(() => this.selectNearestCard());
            },
            { passive: true, signal: this.abortController.signal }
          );

          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const selectedCard = event.target.closest('[data-testimonial-card]');
              if (!selectedCard) return;
              this.select(Number.parseInt(selectedCard.dataset.testimonialIndex, 10), true);
            },
            { signal: this.abortController.signal }
          );

          this.select(this.activeIndex, false);
          window.requestAnimationFrame(() => {
            this.scrollToCard(this.activeIndex, 'auto');
          });
        }

        disconnectedCallback() {
          this.abortController?.abort();
          window.cancelAnimationFrame(this.scrollFrame);
        }

        select(index, shouldScroll) {
          const nextIndex = Math.min(Math.max(index, 0), this.cards.length - 1);
          this.activeIndex = nextIndex;

          this.cards.forEach((card, cardIndex) => {
            const isActive = cardIndex === nextIndex;
            card.classList.toggle('is-active', isActive);
            if (isActive) {
              card.setAttribute('aria-current', 'true');
            } else {
              card.removeAttribute('aria-current');
            }
          });

          if (this.previousButton) this.previousButton.disabled = nextIndex === 0;
          if (this.nextButton) this.nextButton.disabled = nextIndex === this.cards.length - 1;

          if (shouldScroll) {
            this.scrollToCard(nextIndex, this.reducedMotion.matches ? 'auto' : 'smooth');
          }
        }

        scrollToCard(index, behavior) {
          const card = this.cards[index];
          if (!card) return;

          const railRect = this.rail.getBoundingClientRect();
          const cardRect = card.getBoundingClientRect();
          const target =
            this.rail.scrollLeft + cardRect.left - railRect.left - (this.rail.clientWidth - cardRect.width) / 2;

          this.rail.scrollTo({ left: Math.max(target, 0), behavior });
        }

        selectNearestCard() {
          const railRect = this.rail.getBoundingClientRect();
          const railCenter = railRect.left + railRect.width / 2;
          let nearestIndex = this.activeIndex;
          let nearestDistance = Number.POSITIVE_INFINITY;

          this.cards.forEach((card, index) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(cardCenter - railCenter);

            if (distance < nearestDistance) {
              nearestDistance = distance;
              nearestIndex = index;
            }
          });

          if (nearestIndex !== this.activeIndex) this.select(nearestIndex, false);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tavia-video-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tavia-video-text')) {
    customElements.define('tavia-video-text', class extends HTMLElement {
      connectedCallback() {
        const video = this.querySelector('video');
        if (!video || this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const start = () => {
          if (!this.isConnected) return;
          video.muted = true;
          video.playsInline = true;
          video.play().catch(() => {});
        };
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) {
              this.observer.disconnect();
              start();
            }
          }, { threshold: 0.25 });
          this.observer.observe(video);
        } else {
          start();
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
